<template>
  <div v-if="!isAdmin" class="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
    <div class="flex items-start gap-3">
      <InfoIcon class="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
      <div class="flex-1">
        <h3 class="text-sm font-medium text-amber-800 mb-1">
          Mode Lecture Seule
        </h3>
        <p class="text-sm text-amber-700">
          Vous consultez cette page en mode lecture seule. 
          Seuls les administrateurs et super-administrateurs peuvent créer, modifier ou supprimer des éléments.
        </p>
        <p class="text-xs text-amber-600 mt-2">
          Pour obtenir des droits d'administration, contactez votre administrateur système.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth';
import { Info as InfoIcon } from 'lucide-vue-next';
import { computed } from 'vue';

const authStore = useAuthStore();

const isAdmin = computed((): boolean => authStore.user?.role === 'admin' || authStore.user?.role === 'superadmin');
</script> 